export default __webpack_public_path__ + "static/media/imageWhy.3660da37.svg";